export const checkIsNoNeedDateSelect = (masterBook) => {
  if (!masterBook.is_ready) {
    console.log("NoNeedDateSelect");
    return true;
  } else {
    return false;
  }
};
